<template>
    <section>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <h2>Fanwalk Brick Options</h2>
                    <div>
                        <p>
                            Bricks are available in two options: an 8” x 8” size with a D.C. United logo, or a 4” x 8” size without a logo. Each brick is customizable with names or messages. All inscriptions are subject to review by D.C. United. You will also have an opportunity to order a display case for your complimentary replica brick, as well as additional replicas. Please call to place an order outside of the contiguous United States (International, Alaska or Hawaii).
                        </p>
                    </div>
                    <catalog></catalog>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import Catalog from './shop/Catalog.vue';
    export default {
        name: 'shop',
        props: {
        },
        mixins: [
        ],
        data: function () {
            return this.getDefaultData();
        },
        components: {
            'catalog': Catalog
        },
        created: function () {
        },
        methods: {
            getDefaultData: function () {
                return {
                }
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Shop.vue?14f18a8a